import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {LoggedUser} from '../../../types/loggedUser';
import {LocalStorageService} from '../../../../api/services/localStorage';
import {MatDialog} from '@angular/material/dialog';
import {AddCompetitorCardComponent} from './add-competitor-card/add-competitor-card.component';
import {Competitor} from '../../../types/competitor';
import {EditCompetitorCardComponent} from './edit-competitor-card/edit-competitor-card.component';
import {LoggedCompetitor} from '../../../types/loggedCompetitor';
import {AddCrewCardComponent} from './add-crew-card/add-crew-card.component';
import {HttpHandlingService} from '../../../../api/services/http-handling.service';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {AddCrewResponseEntity} from '../../../types/addCrewResponseEntity';
import {CrewSample} from '../../../types/crew';
import {EditCrewCardComponent} from './edit-crew-card/edit-crew-card.component';
import {EditCrewCardInfo} from '../../../types/editCrewCardInfo';
import {SERVER_API_URL} from '../../../types/app.constants';

@Component({
  selector: 'app-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss']
})
export class ProfileInfoComponent implements OnInit {

  loggedUser = new LoggedUser();
  loggedCompetitor: LoggedCompetitor;
  crews: CrewSample[];

  @Output() onCloseSideNav = new EventEmitter<void>();

  @Input() sideNavMode = false;

  constructor(private localStorage: LocalStorageService, public dialog: MatDialog,
              private httpHandlingService: HttpHandlingService, private http: HttpClient) {}

  ngOnInit(): void {
    if (this.localStorage.get('loggedUser') !== null) {
      this.loggedUser = this.localStorage.get('loggedUser') as LoggedUser;
    }
    if (this.localStorage.get('loggedCompetitor') !== null) {
      this.loggedCompetitor = this.localStorage.get('loggedCompetitor') as LoggedCompetitor;
    }
    this.crews = this.getCrewsRelatedForCompetitor();
  }

  /**
   * function which opens the dialog for creating new competitor card
   */
  openAddCompetitorCardDialogDialog(): void {
    this.onCloseSideNav.emit();
    this.dialog.open(AddCompetitorCardComponent);
  }

  /**
   * function which opens the dialog for receiving competitor from database and updating competitor
   */
  openEditCompetitorCardDialogDialog(): void {
    this.onCloseSideNav.emit();
    const competitorURL = SERVER_API_URL + '/api/competitors/user/' + this.loggedUser.id;
    let competitor = null;
    this.http.get<Competitor>(competitorURL,
      {headers: this.httpHandlingService.authorizationHeaders()}).subscribe((competitorFromServer: Competitor) => {
      competitor = competitorFromServer;
      },
      (error: HttpErrorResponse) => { this.handleRegistrationHttpErrors(error); },
      () => { this.dialog.open(EditCompetitorCardComponent, {data: competitor}); });
  }

  /**
   * function which opens the dialog for inserting competitor into crew
   * this function loads all competitors and array of used crew numbers
   */
  openAddCrewCardDialog(): void {
    this.onCloseSideNav.emit();
    const getCrewNumbersWithCompetitorsURL = SERVER_API_URL + '/api/crewNumbersWithCompetitors';
    let crewNumbersWithCompetitors = null;
    this.http.get<AddCrewResponseEntity>(getCrewNumbersWithCompetitorsURL,
      {headers: this.httpHandlingService.authorizationHeaders()}).subscribe(result => {
        crewNumbersWithCompetitors = result as AddCrewResponseEntity;
      },
      (error: HttpErrorResponse) => { this.handleRegistrationHttpErrors(error); },
      () => { this.dialog.open(AddCrewCardComponent, {data: crewNumbersWithCompetitors}); }
    );
  }

  /**
   * function for evaluation, if logged user has created his competitor card
   * if competitor card is not created, user is not able to create new crew
   */
  competitorCardIsNotCreated(): boolean {
    return this.loggedCompetitor === null || this.loggedCompetitor === undefined ;
  }

  /**
   * function for evaluation, if logged competitor is already in crew
   */
  competitorIsAlreadyInCrew(): boolean {
    return this.localStorage.get('loggedCompetitorCrews') !== null && (this.localStorage.get('loggedCompetitorCrews') as []).length > 0;
  }

  /**
   * function for retrieving crews from local storage
   */
  getCrewsRelatedForCompetitor(): CrewSample[] {
    return this.localStorage.get('loggedCompetitorCrews');
  }

  /**
   * function for opening crew detail dialog according to selected crew
   * @param crew from evaluation, which crew has to be opened
   */
  openCrewDetailDialog(crew: CrewSample): void {
    this.onCloseSideNav.emit();
    const getCrewNumbersWithCompetitorsURL = SERVER_API_URL + '/api/crewNumbersWithCompetitors';
    let crewNumbersWithCompetitorsAndSelectedCrew = null;
    this.http.get<AddCrewResponseEntity>(getCrewNumbersWithCompetitorsURL,
      {headers: this.httpHandlingService.authorizationHeaders()}).subscribe((result: AddCrewResponseEntity) => {
        crewNumbersWithCompetitorsAndSelectedCrew = new EditCrewCardInfo(crew, result);
      },
      (error: HttpErrorResponse) => { this.handleRegistrationHttpErrors(error); },
      () => { this.dialog.open(EditCrewCardComponent, {data: crewNumbersWithCompetitorsAndSelectedCrew}); }
    );
  }

  /**
   * function for user logout
   */
  onLogout(): void {
    this.onCloseSideNav.emit();
    this.localStorage.remove('loggedUser');
    this.localStorage.remove('loggedCompetitor');
    this.localStorage.remove('loggedCompetitorCrews');
    window.location.reload();
  }

  /**
   * function for handling HTTP errors in the process of receiving competitor
   */
  handleRegistrationHttpErrors(error: HttpErrorResponse): void {
    if (error.status === 0) {
      alert(error.message);
    }
  }
}
